import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, Inject} from '@angular/core';
import {ProjectService} from '../project/project.service';
import {DomSanitizer} from '@angular/platform-browser';
import {DOCUMENT} from '@angular/common';




@Component({

    selector:'notepad',
    template:`
      <div class="modal" [style.display]="!hide ? 'inline' : 'none'" >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <!-- header-->
            <div class="modal-header">
                <h4 class="modal-title"><span><img alt="icon" class="appWindow" src="../../../assets/images/notepad.png"></span></h4>
                <h4>Logs</h4>
                <button (click)="toggleDialog();" type="button" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                  <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                </button>
            </div>
            <div class="modalBodyContainer">
              <div *ngIf="!validImgFile(this.resourceLink)" class="modal-body">
                <!-- Texts -->
                  <ng-container>
                      <object style="width:100%;height:500px;" type="text/html" [data]="this.sanitizer.bypassSecurityTrustResourceUrl(generateLogUrl())"></object>
                  </ng-container>
              </div>
                <div *ngIf="validImgFile(this.resourceLink)" class="modal-body imgBody">
                    <!-- Texts -->
                   <img alt="previewImg" [src]="resourceLink">
                </div>
              <!-- footer-->
              <div class="modal-footer ">
              </div>
            </div>
          </div>
        </div>
      </div>`,
    styles:[`
        .iFrame{width: 100%;height:100%;}
        .imgBody{background-color: black;}
        .modal-header{
          background-image: url("../../assets/images/headerBack.jpg");
          color:antiquewhite;
          border-top-right-radius: 10px;
          border-top-left-radius: 10px;
          height:56px;
        }
        .modal-content{
          border-top-right-radius: 18px;
          border-top-left-radius: 18px;
          padding-left: 3px;
          padding-right: 3px;
          background-color: #0064FE;
          padding-bottom: 3px;
        }
        .modal-title{margin-left:15px;}
        .modal-body {
          padding-left: 10px;
          padding-right: 10px;
          max-height: 700px;
          background-color:#ECE8E5;
        }
        .modal-footer{
          background-color: #ECE8E5;
          border-top:groove;
        }
        .modal .modal-body {
            overflow-y: auto;
       }

        .modal-body thead {
          position: sticky;
          top:0;
        }

        .modalBodyContainer{
          background-color:  #ECE8E5;
        }

        ::-webkit-scrollbar {
          width: 14px;
          height: 5px;
          background-color: #F5F3F0;
        }
        ::-webkit-scrollbar-thumb {
          height: 6px;
          border: 4px solid rgba(0, 0, 0, 0);
          background-clip: padding-box;
          -webkit-border-radius: 7px;
          background-color:#BACEFF;
          -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
        }
        ::-webkit-scrollbar-button {
          width: 14px;
          height: 14px;
          display: none;
        }
        ::-webkit-scrollbar-corner {
          background-color: transparent;
        }
        .btn-outline-danger {
          background-color: #d6462e;
          border-style: solid;
          border-color: white;
          border-width: 2px;
          padding: 0;
          margin-top: 2px;
        }
        .modal-lg{max-width:1550px;}
        .closeX{color:azure;size:25px;}
        .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}
        .closeIcon{ width: 32px;}
        .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
        .btn-danger:hover{background-color: #FF2400;}
        .appWindow{height:25px;margin-right:140px;}
        .genericIcon{height:90px;}

        .htmlLog table { margin-left: 2em; margin-right: 2em; border-left: 2px solid #AAA; }
        .htmlLog table tr.even { background: #FFFFFF; }
        .htmlLog table tr.odd { background: #EAEAEA; }
        .htmlLog table tr.warn td.Level, tr.error td.Level, tr.fatal td.Level {font-weight: bold; color: #FF4040 }
        .htmlLog table td { padding-right: 1ex; padding-left: 1ex; border-right: 2px solid #AAA; }
        .htmlLog table td.Time, td.Date { text-align: right; font-family: courier, monospace; font-size: smaller; }
        .htmlLog table td.Thread { text-align: left; }
        .htmlLog table td.Level { text-align: right; }
        .htmlLog table td.Logger { text-align: left; }
        .htmlLog table td.Logger { text-align: left; }
        .htmlLog table tbody tr .header { background: #596ED5; color: #FFF; font-weight: bold; font-size: larger; }
        .htmlLog table td.Exception { background: #A2AEE8; font-family: courier, monospace;}
    `]
})

export class NotepadComponent implements OnChanges {
    // the below method is to replace all these inputs.
    @Input('title') title:string;
    @Input('text') text:string;
    @Input() logType:string;
    private hide = true;
    @Output() OkClick: EventEmitter<any> = new EventEmitter();
    @Input('statusCode') statusCode = 200;
    private pretty = require('pretty');

    private resourceLink:string;

    private fileName = '';
    // private  objectURL: SafeUrl;
    private jpg: any;



    constructor(private _service:ProjectService,private sanitizer:DomSanitizer) {}


    onOkClicked() {
        this.OkClick.emit();
    }

    public defineModal(msg:string,title:string,statusCode:number) {
        this.text = msg;
        this.title = title;
        this.statusCode =  statusCode;
    }

    toggleDialog() {
        this.hide = !this.hide;
    }

    /*previewFile(pId,qId,tId,clientTypeId,file:string) {

        this.resourceLink = ServerAddress.getInstance().getValue()+"/projects/"+pId+"/"+qId+'/'
        this.fileName = file;
        this._service.downloadPreviewContent(pId,qId,tId,clientTypeId,file).subscribe( (blob:any) => {
            if(!this.validImgFile(file)) {
                this.text = btoa(blob);
                const fic = new File([blob],file);
            } else {
                const uints = new Uint8Array(blob);
                const base64 = btoa(blob);// blob.toString('base64');
                const reader = new FileReader();
                reader.onload = (e) => this.objectURL = e.target;
                reader.readAsDataURL(new Blob([blob]));

                // this.objectURL =this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(blob));
            }
        });
    }*/

    setResourceLink(link:string) {
        this.text = '';
        this.resourceLink = link;
        if(!this.validImgFile(link)) {
            this._service.downloadPreviewContent(link).subscribe(ans => {
                this.text = ans;
            },
            err => {
                this.text = 'This link:'+link+' has no content associated';
            });
        }
    }

    validImgFile(fileName: string):boolean {
        const regexpNumber =  RegExp('.(jpg|png|bmp|gif|jpeg)$');
        if(regexpNumber.test(fileName)) {
            return true;
        }return false;
    }

    ngOnChanges(changes: SimpleChanges): void {

       // render(this.text, document.getElementById('htmlLog'));
    }

    private generateLogUrl():string {
        let url = 'http://'+window.location.hostname+':'+window.location.port+'/logs/';
        if(this.logType == null) {
            return '';
        }
        if(this.logType.includes('standard')) {
            url+='juju/htmlLog/main.html';
        } else {
            url+='spring.html';
        }
        console.log(url);
        return url;
    }
}
